import api from './api';

// YÖNETİM uçları (CN.Read / CN.Write). Self-servis okumalar ve QR okutma
// myMealService.js'e taşındı — bkz. MyMealController.
export const getMealEntries = (params) => api.get('/v1/meal-entries', { params });
export const getMealStatistics = (params) => api.get('/v1/meal-entries/statistics', { params });
export const getMealCostReport = (params) => api.get('/v1/meal-entries/cost-report', { params });
export const cancelMealEntry = (id, data) => api.post(`/v1/meal-entries/${id}/cancel`, data);
